import React, { useState } from 'react';
import PropTypes from 'prop-types';

import RichTextModal from '../RichTextModal/RichTextModal';
import RichTextPropTypes from '../../prop-types/rich-text';

import * as Styled from './InfoDialog.styled';

/**
 * Renders a link that opens a Rich Text Model with content
 */
const InfoDialog = ({
  cta,
  backgroundColor,
  className,
  title,
  sections,
  defaultSection
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Styled.CTA
        className={className}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        {cta}
      </Styled.CTA>
      <RichTextModal
        title={title}
        backgroundColor={backgroundColor}
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false);
        }}
        sections={sections}
        defaultSection={defaultSection}
      />
    </>
  );
};

InfoDialog.propTypes = {
  className: PropTypes.string,
  /**
   * link text that opens modal on click
   */
  cta: PropTypes.string.isRequired,
  /**
   * title of the modal
   */
  title: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  /**
   * Array of Rich Text sections
   */
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.shape(RichTextPropTypes),
      label: PropTypes.string
    })
  ).isRequired,
  /**
   * a single Rich Text section to be shown when initially opening the modal
   */
  defaultSection: PropTypes.shape({
    label: PropTypes.string
  })
};

InfoDialog.defaultProps = {
  className: undefined,
  backgroundColor: undefined,
  defaultSection: undefined
};

export default InfoDialog;
